import { NdpsDomainResponse } from '../../types/bff-types';
import { fetchNdpsResponses } from './fetch/ndps-fetch';

export const sendForm = async (
	formData: FormData,
): Promise<{
	success: boolean;
	response: NdpsDomainResponse | null;
}> => {
	const response = fetchNdpsResponses(formData);

	return response.then((res) => {
		return {
			success: Boolean(res && res.status.code === 200),
			response: res,
		};
	});
};
